// Relay reader metadata must retain its identity when cloning query results.
export const CLIENT_EDGE_TRAVERSAL_PATH_KEY = '__clientEdgeTraversalPath';
